/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Info/StartedAt
 * @desc Showing experimentWorkflow.due_at
 */

import { ExperimentWorkflowInfoDateAt } from 'labstep-web/components/ExperimentWorkflow/Info/DateAt';
import type React from 'react';
import type { ExperimentWorkflowInfoStartedAtProps } from './types';

export const ExperimentWorkflowInfoStartedAt: React.FC<
  ExperimentWorkflowInfoStartedAtProps
> = ({ experimentWorkflow }) => (
  <ExperimentWorkflowInfoDateAt
    experimentWorkflow={experimentWorkflow}
    field={
      experimentWorkflow.statusType !== 'unstarted'
        ? 'started_at'
        : 'start_planned_at'
    }
    label={
      experimentWorkflow.statusType !== 'unstarted'
        ? 'started'
        : 'planned start'
    }
    dateTimePickerOptions={{
      maxDate: experimentWorkflow.activeEnd,
    }}
    popup={
      experimentWorkflow.activeStart &&
      (experimentWorkflow.statusType !== 'unstarted'
        ? 'Date started'
        : 'Planned Start Date')
    }
  />
);
